import React from 'react';
import { useCart } from '../CartContext';
import '../stylesheets/ShoppingCart.css';

const ShoppingCart = ({ cartItems, setShowCart }) => {
  const { setCartItems } = useCart();

  const totalAmount = cartItems.reduce((acc, item) => acc + item.ItemPrice * item.amount, 0);

  const increaseAmount = (id) => {
    const updatedCartItems = cartItems.map(item => {
      if (item.id === id) {
        return { ...item, amount: item.amount + 1 };
      }
      return item;
    });
    setCartItems(updatedCartItems);
  };

  const decreaseAmount = (id) => {
    const updatedCartItems = cartItems.map(item => {
      if (item.id === id && item.amount > 1) {
        return { ...item, amount: item.amount - 1 };
      }
      return item;
    });
    setCartItems(updatedCartItems);
  };

  return (
    <div className='shopping-cart-cont'>
      <h2>Carrito de Compras</h2>
      <button onClick={() => setShowCart(false)} className='close-cart-btn'>Cerrar</button>
      <div className='cart-items'>
        {cartItems.length > 0 ? (
          cartItems.map((item) => (
            <div key={item.id} className='cart-item'>
              <div className='cart-item-image'>
                <img
                  src={`/img/items/${item.ItemName}/${item.ItemImages[0]}`}
                  alt={item.ItemName}
                />
              </div>
              <div className='cart-item-details'>
                <h3>{item.ItemName.replace(/_/g, ' ')}</h3>
                <p>Precio: ${item.ItemPrice.toLocaleString('es-ES')} COP</p>
                <div className='quantity-control'>
                  <button disabled={item.amount <= 1} onClick={() => decreaseAmount(item.id)}>-</button>
                  <span>{item.amount}</span>
                  <button onClick={() => increaseAmount(item.id)}>+</button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No hay productos en el carrito.</p>
        )}
      </div>
      <div>
        <h2>Total: ${totalAmount.toLocaleString('es-ES')} COP</h2>
      </div>
    </div>
  );
};

export default ShoppingCart;
